/**
 * External Dependencies
 */
// import 'jquery';
import $ from 'jquery';
import './header';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/tab';
import BodyMoving from './modules/bodymoving';
// import * as BodyMoving from './modules/bodymoving';

$(() => {
  // bubble js
  var btnBubble = document.querySelectorAll('.btn-bubble');
  if (btnBubble.length > 0) {
    $('.btn-bubble').wrapInner($('<strong></strong>'));
    $('.btn-bubble').prepend(
      '<span></span><span></span><span></span><span></span>'
    );
  }
  const inputField = document.querySelector('#tfa_1');

  /*$('.theme-footer-right #submit_button').on('click', function(e){
        e.preventDefault();
        var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
        var emailAddr = $('#tfa_1').val();
        var errorMessage = '<span class="wpcf7-not-valid-tip" aria-hidden="true">The e-mail address entered is invalid.</span>';
        if (emailAddr.match(validRegex))
            $(".theme-footer-right-top form").submit();
        else{
            console.log($('#tfa_1').val());
        }

    });*/
});

$(document).on('click', '.card-b06', function (e) {
  var currentUrl = $(this).attr('data-js-href');

  if (currentUrl != '') {
    e.preventDefault();
    window.location.href = currentUrl;
  }
});

$(document).on('click', '.close-popup', function (e) {
  e.preventDefault();
  const whcModalclosetime = new Date(
    new Date().getTime() + 24 * 60 * 60 * 1000
  ).toLocaleString();

  if ($('.modal-email-popup').hasClass('open'))
    $('.modal-email-popup').removeClass('open');
  if ($('.hasResponse').hasClass('dnone')) {
    document.cookie =
      'STYXKEY_whc_signupc=' +
      whcModalclosetime +
      '; max-age=' +
      1 * 24 * 60 * 60 +
      '; path=/';
  }
});

window.addEventListener('DOMContentLoaded', () => {
  document.querySelector('.bodymoving');
  new BodyMoving();
});

// if(document.querySelector("#form-shortcode-wrap .primaryAction") != null)
//     document.querySelector("#form-shortcode-wrap .primaryAction").value="Continue sign up in next step";
